import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const rapidboardLastVisitedProjectRedirectRoute: InvariantJiraRoute = {
	name: 'rapidboard-last-visited-project-redirect',
	path: '/secure/RapidBoard.jspa',
	query: ['projectKey'],
	__unsafeOrder: 1,
};
